/**
 * Hidden FireCMS properties for publish snapshot / timestamp.
 */
export const publishedSnapshotProperties = {
  published_snapshot: {
    name: "Live snapshot",
    dataType: "map" as const,
    keyValue: true as const,
    disabled: { hidden: true, clearOnDisabled: false },
    description:
      "Last live content. Keeps the live site stable while editing; used by Revert to live.",
  },
  published_at: {
    name: "Last published at",
    dataType: "date" as const,
    disabled: { hidden: true, clearOnDisabled: false },
  },
};

export const STATUS_FIELD_DESCRIPTION =
  "Draft / Ready for first publish. Live = on site and in sync. Live · Draft = on site with unpublished CMS edits. Live · Ready = on site and queued for the next Publish.";
